export default "__VITE_ASSET__Ca1tCyRK__"